import React from "react";
import Section from "../components/Section";

function Syllabus() {

  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./syllabus/Syllabus_header.png"
        alt="Syllabus"
        className="header-img"
      />

      <Section
        header={<h1 className="section-header">Learning Outcomes</h1>}
        content={
          <div className="section-text">
          <p>
            <ul className="section-text">
              <li>Analyze and critically evaluate existing tangible/embodied interaction systems using formal knowledge from the field.</li>
              <li>Formulate research questions, prepare a research plan, and carry out research in the area of tangible and embodied interaction design.</li>
              <li>Devise, design, develop, and evaluate tangible/embodied interaction systems and contextualize them within the field.</li>
            </ul>
            </p>
          </div>
        }
      />

      <Section
        header={<h1 className="section-header">Logistics</h1>}
        content={
          <p className="section-text">
            The class runs from 12:10-3pm on Thursdays in BTS N103. Attendance is mandatory.
          </p>
        }
      />

      <Section
        header={<h1 className="section-header">Expectations</h1>}
        content={
          <p className="section-text">
            The Synlab is an active research lab that has been running a research-based course since 2005, first at Georgia Tech and now at TMU. Students have the opportunity to participate in new and ongoing projects in the lab. Each student is expected to join one research project team for the semester. Project teams present their workplans at the beginning of the semester, their work-in-progress during the semester, and their final projects at the end of the semester. For work-in-progress presentations, teams are encouraged to engage the rest of the lab in their work process through whatever means suits the current stage of their project (e.g., design brainstorming, demonstrating or testing a prototype, etc.)
          </p>
        }
      />

      {/* Images side by side */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <img
          src="./syllabus/table01.png"
          alt="Undergraduate Students"
          style={{ width: "100%", display: "block" }}
        />
        <img
          src="./syllabus/table02.png"
          alt="Graduate Students"
          style={{ width: "100%", display: "block" }}
        />
      </div>

      <Section
        header={<h1 className="section-header">Grading</h1>}
        content={
          <p className="section-text">
            Feedback is given orally by the instructor and the team leads in response to presentations and progress reports made during class and project team meeting times. The project is team-based but students are graded individually on all project work. Grades and written feedback are provided to each student individually and to each team as a whole after each stage of project work. The instructor meets with teams periodically during the research process to provide guidance and feedback. Broadly, grades in the course are weighted as above and are based on:
            <ul className="section-text">
              <li>
                Your research plan, how well you follow it and/or adjust as needed (e.g., setting new goals, revising schedule, etc.)
              </li>
              <li>
                Work to support the research (technical, evaluation, documentation, etc.; may differ across teams and/or team members)
              </li>
              <li>
                Research output (designs, prototypes, working systems, demo videos, papers, etc.; may differ across teams and/or team members)
              </li>
              <li>
                Participation in and contribution to the lab/class (includes readings, reviews, inspirations, tutorials/workshops, etc.)
              </li>
            </ul>
          </p>
        }
      />

      <Section
        header={<h1 className="section-header">Materials</h1>}
        content={
          <p className="section-text">
            <b>[Workspace]</b> - Projects make use of the{" "}
            <a href="https://drive.google.com/drive/u/0/folders/1TF23zI4mJ-eow6EsvFm6Q9c5WzplxBKl" target="_blank" rel="noopener noreferrer">
              SynlabCourse Team Google Drive
            </a>
            <br />
            <b>[Mailing List]</b> - synlabcourse@googlegroups.com
          </p>
        }
      />

      <Section
        header={<h1 className="section-header">Policies & Accommodations</h1>}
        content={
          <p className="section-text">
            Students are required to adhere to all relevant University policies, such as the Student Code of Non-Academic Conduct and the Academic Integrity Policy. Students are expected to be present at class sessions and to attend to and actively respond to presentations by the instructor and fellow students and to participate in learning activities. Students who require learning support are encouraged to visit the Student Learning Support Centre. Students who require accommodations must register with Academic Accommodation Support (AAS) and provide the appropriate documentation. Students who experience extenuating circumstances that impact their ability to meet deadlines or fulfill course requirements must talk to the instructor and can submit an Academic Consideration Request (ACR). For more information, please visit:
            
            <ul className="section-text">
              <li>
                <a href="http://www.torontomu.ca/academicintegrity/" target="_blank" rel="noopener noreferrer">
                  Academic Integrity
                </a>
              </li>
              <li>
                <a href="https://www.torontomu.ca/senate/policies/student-code-of-non-academic-conduct-policy-61/" target="_blank" rel="noopener noreferrer">
                  Student Code of Non-Academic Conduct
                </a>
              </li>
              <li>
                <a href="https://www.torontomu.ca/senate/policies/academic-integrity-policy-60/" target="_blank" rel="noopener noreferrer">
                  Academic Integrity Policy
                </a>
              </li>
              <li>
                <a href="https://www.torontomu.ca/student-life-and-learning/learning-support" target="_blank" rel="noopener noreferrer">
                  Student Learning Support Centre
                </a>
              </li>
              <li>
                <a href="https://www.torontomu.ca/accommodations/" target="_blank" rel="noopener noreferrer">
                  Academic Accommodation Support
                </a>
              </li>
            </ul>
          </p>
        }
      />

      <Section
        header={<h1 className="section-header">Non-Disclosure Agreement</h1>}
        content={
          <p className="section-text">
            Please read and sign the following{" "}
            <a href="https://drive.google.com/file/d/163OP_a8QiQb3H8q-IKUSHOOltfLpn0D7/view" target="_blank" rel="noopener noreferrer">
              NDA form
            </a>{" "}
            and submit it to Andrey via email
            (amiroshnichenko@torontomu.ca)
          </p>
        }
      />
    </div>
  );
}

export default Syllabus;